import { EndpointPermissionRule } from '../core/permissions/endpoint-permission.models';
import { P } from './portal-permissions.constants';

const TEDARIKCI = P.Tedarikci.Module;

function multiRead(
  pattern: string,
  methods: ('GET' | 'POST')[] = ['GET', 'POST'],
): EndpointPermissionRule[] {
  return methods.map((method) => ({
    method,
    pattern,
    permissionKeys: [TEDARIKCI],
    access: 'read' as const,
  }));
}

function multiWrite(
  pattern: string,
  methods: ('GET' | 'POST')[] = ['POST'],
): EndpointPermissionRule[] {
  return methods.map((method) => ({
    method,
    pattern,
    permissionKeys: [TEDARIKCI],
    access: 'write' as const,
  }));
}

/** Tedarikçiler — tek modül key (Tedarikci). */
export const TEDARIKCI_ENDPOINT_EXTRA_RULES: readonly EndpointPermissionRule[] =
  [
    ...multiRead('api/Company/GetMySuppliers', ['GET']),
    ...multiRead('api/Company/GetCarbonGateCatalog', ['POST']),

    ...multiWrite('api/Company/CreateSupplier'),
    ...multiWrite('api/Company/UpdateSupplier'),
    ...multiWrite('api/Company/DeleteSupplier'),
  ];
